<div class="border_wrapper" style="height: 100%; position: relative">

    <!-- Piezo Name -->
    <div class="powertrain_name">
        {{ piezoName || 'STAND 12' }}
    </div>

    <!-- Main Layout -->
    <div class="justify_center_flex">

        <!-- Image + Sensors -->
        <div class="cursor-move flex_9" style="position: relative; width: 85%">

            <!-- Piezo Image -->
            <img [src]="piezoImg || './assets/default-piezo.png'" class="img" style="width:100%; height:205px" />

            <!-- Sensors -->
            <div class="new_sensor_style rounded-2" *ngFor="let sensor of sensors" [matTooltip]="showTooltip(sensor)"
                matTooltipClass="tooltip_1" [ngStyle]="{
          top: sensor.yPercentage + '%',
          left: sensor.xPercentage + '%',
          position: 'absolute',
          'background-color': sensor.color,
          cursor: 'pointer'
        }" (click)="onSensorClick(sensor)">
                <div class="sensor_no">
                    {{ sensor.sensorDNames }}
                </div>

                <img src="./assets/wifion.png" width="16" height="16"
                    *ngIf="sensor.device_status === 1 || sensor.device_status === 0" />

                <img src="./assets/wifioff.png" width="16" height="16" *ngIf="sensor.device_status === 2 || sensor.device_status === 3" />
            </div>
        </div>

        <!-- Physical Images -->
        <div class="m-2">
            <div class="flex_1 phy_images_box" *ngFor="let img of piezoPhyImgs">
                <div class="physical_img_box" (click)="showPhysicalImage(img)">
                    <img class="w-100 h-100" [src]="img.url" />
                </div>
            </div>
        </div>
    </div>

    <!-- View Piezo Image -->
    <div class="powertrain_eye_icon" (click)="viewPiezoImages()">
        <mat-icon>remove_red_eye</mat-icon>
    </div>

    <!-- Edit Piezo -->
    <div class="powertrain_edit_icon" (click)="editPiezo()">
        <mat-icon>edit</mat-icon>
    </div>

    <!-- Add Physical Image -->
    <div class="powertrain_add_icon" *ngIf="piezoPhyImgs.length < 4" (click)="addImage()">
        <mat-icon>add_photo_alternate</mat-icon>
    </div>

    <!-- Asset Status -->
    <div class="powertrain_add_icon">
        <div class="asset_running_dot" [ngClass]="isAssetRunning ? 'blue_bg' : 'gray_bg'"
            [matTooltip]="isAssetRunning ? 'Asset Running' : 'Asset Idle'" matTooltipClass="tooltip1"></div>
    </div>

</div>

<app-powertrain-modal [type]="'img_modal'" [subsystem_id]="subsystem_id" *ngIf="add_physical_img_modal"
    (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'piezo_powertrain_image'" [subsystem_id]="subsystem_id" *ngIf="show_powertrain_img"
    (closePowertrainImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'piezo_powertrain_phy_image'" [data]="selected_img" *ngIf="show_physical_image"
    (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'piezo_powertrain_phy_image'" [data]="selected_img" *ngIf="show_physical_image"
    (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>